import { WebRTCSocket } from "./WebRTCSocket";

var WebRTCSocketProvider = function () {
  function WebRTCSocketProvider(configuration) {
    this.rtcConfiguration = configuration !== null && configuration !== void 0 ? configuration : {
      iceServers: [{
        urls: "stun:stun.l.google.com:19302"
      }, {
        urls: "stun:global.stun.twilio.com:3478"
      }]
    };
  }

  WebRTCSocketProvider.prototype.createUhstSocket = function (relayClient, params, debug) {
    return new WebRTCSocket(relayClient, this.rtcConfiguration, params, debug);
  };

  return WebRTCSocketProvider;
}();

export { WebRTCSocketProvider };